module.exports = __webpack_public_path__ + "img/certi-bruit.9df01562.png";